import { Box, Typography } from '@material-ui/core'
import React from 'react'

export const BaseHeader = ({ fontSize = 16, label, pt = 2, pb = 2, textTransform = 'capitalize' }) => {
	return (
		<Box width="100%" pt={pt} pb={pb}>
			<Typography style={{ fontSize, fontWeight: '800', textTransform }}>{label}</Typography>
		</Box>
	)
}

export const Title = ({ fontSize = 16, label, pt = 3, pb = 3, textTransform = 'uppercase' }) => {
	return <BaseHeader fontSize={fontSize} label={label} pt={pt} pb={pb} textTransform={textTransform} />
}

export const SubTitle = ({ fontSize = 16, label, pt = 4, pb = 2, textTransform = 'capitalize' }) => {
	return <BaseHeader fontSize={fontSize} label={label} pt={pt} pb={pb} textTransform={textTransform} />
}
